import { Chip as MuiChip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import { extendedTheme } from '../theme/extended'

export type ChipColor = 'blue' | 'green' | 'red'

interface ChipProps {
  color: ChipColor
  label: string
}

const useStyles = (color: ChipColor) =>
  makeStyles(() => ({
    root: {
      backgroundColor: () => {
        const { blue, categoryGreen, red } = extendedTheme.colors.brand
        switch (color) {
          case 'green':
            return categoryGreen
          case 'red':
            return red
          case 'blue':
          default:
            return blue
        }
      },
      borderRadius: '8px',
      color: 'white',
      fontFamily: extendedTheme.fontFamilies.robotoCondensed,
      marginRight: '5px',
    },
  }))()

export const Chip = ({ color, label }: ChipProps) => {
  const classes = useStyles(color)
  return <MuiChip className={classes.root} label={label} size="small" clickable />
}
